"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var ModalAlertContent_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalAlertContext/ModalAlertContent"));
var Text_1 = __importDefault(require("shared/components/Text"));
var Intro = function (_a) {
    var onClose = _a.onClose, buttonAction = _a.buttonAction;
    return ((0, jsx_runtime_1.jsx)(ModalAlertContent_1.default, { onClose: onClose, status: "success", title: "Add authenticator app", icon: "/ShieldCheck.svg", description: ((0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, color: "riverstone", fontWeight: 600 }, { children: "Enhance the security of your account required for all users connecting to Xero or QuickBooks accounts." }))), buttonText: "Add authenticator app", buttonAction: buttonAction }));
};
exports.default = Intro;
